/* eslint-disable prettier/prettier */
/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row, Space, Input, message } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { selectCurrentUser } from 'Store/user/selector'
import {
  formatDateTime,
  getMenuTypeName,
  getRequestString,
  getTaxInvoiceType,
  numberWithComma,
  toDateQuery,
} from 'helpers/format'
import { TableListPage } from 'Components/common/Table'
import { PrimaryButton } from 'Components/button'
import { Pagination } from 'Components/Pagination'
import { menuTaxInvoiceType, menuTaxtatus, TaxInvoiceType, Taxtatus } from 'helpers/constanst'
import { RangeDateItem, SelectItem } from 'Components/form'
import { taxListAPI } from 'Store/tax-management/api'
import { TaxListData, TaxListReq } from 'Store/tax-management/types'
import { selectTaxList, selectTaxListEvent } from 'Store/tax-management/selector'
import { StatusTag } from 'Components/utilities'
import TaxDetail from './TaxDetail'
import { ConfirmExport } from 'Components/modal'
import { appConfig } from 'config'
import { APIPath } from 'services/APIPath'
import Axios from 'axios'
import downloadCSVFile from 'helpers/export'
import SupplierTaxDetail from './SupplierTaxDetail'
import theme from 'Components/common/Theme'

type Props = {} & ReduxProps

const TaxList: React.FunctionComponent<Props> = props => {
  const { currentUser, dataList, event } = props
  const dispatch = useDispatch()
  const [exportDailog, setExportDailog] = useState(false)
  const [exporting, setExporting] = useState(false)

  const [filter, setFilter] = useState({
    keyword: '',
    start_date: '',
    end_date: '',
    status: '',
    invoice_type: '',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const [drawer, setDrawer] = useState(false)
  const [selectedData, setSelectedData] = useState(undefined as any)
  const meta = dataList.meta
  const datas = dataList.data

  const onGetDataList = (): void => {
    const req: TaxListReq = {
      keyword: filter.keyword?.trim() || '',
      status: filter.status,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
      invoice_type: filter.invoice_type,
    }

    dispatch(taxListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
  }

  const onExport = (): void => {
    setExporting(true)
    const req: TaxListReq = {
      keyword: filter.keyword?.trim() || '',
      status: filter.status,
      // page: pagination.Page,
      // per_page: pagination.RowPerPage,
      export: true,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
      invoice_type: filter.invoice_type,
    }
    const endPoint = appConfig.backofficeEndpoint + `${APIPath.taxList}?${getRequestString(req)}`
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'X-Mid': currentUser?.activeMerchant?.id || 0,
      },
    }
    Axios.get(endPoint, header)
      .then((res: any) => {
        const reportData = res?.data
        let fileName = `รายงานออกใบกำกับภาษี ประจำวันที่ ${req.start_date} - ${req.end_date}.csv`
        if (req.start_date == '' || req.end_date == '') {
          fileName = 'รายงานออกใบกำกับภาษี'
        }
        downloadCSVFile(reportData, fileName)
        setExporting(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetDataList()
    }
  }, [pagination])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const handleChangeDate = (statDate: string, endDate: string) => {
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
    })
  }

  const renderStatus = (status: Taxtatus) => (
    <StatusTag isPass={status === Taxtatus.SUCCESS} text={getMenuTypeName(menuTaxtatus, status)} />
  )

  const renderTaxType = (type: string) => {
    const statusResult = getTaxInvoiceType(type)
    return <StatusTag text={statusResult.text} color={statusResult.color} />
  }

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onClickEdit = (taxItem: TaxListData) => {
    setSelectedData(taxItem)
    onOpenDrawer()
  }

  const onSuccess = () => {
    //onCloseDrawer()
    onGetDataList()
  }

  const DetailDrawer = (
    <TaxDetail
      id={selectedData?.id || 0}
      orderNo={selectedData?.order_no || ''}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
    />
  )

  const SupplierDetailDrawer = (
    <SupplierTaxDetail
      id={selectedData?.id || 0}
      orderNo={selectedData?.order_no || ''}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
    />
  )

  const ConfirmExportModal = (
    <ConfirmExport
      title="ยืนยันการส่งออกรายการคำสั่งซื้อ"
      label="วันที่สั่งซื้อ"
      confirmBtnTxt="Export"
      description="หมายเหตุ : สามารถส่งออกข้อมูลได้สูงสุด 1 เดือน"
      isShow={exportDailog}
      handleOk={onExport}
      handleCancel={() => setExportDailog(false)}
      loading={exporting}
    />
  )

  const columns = [
    // {
    //   title: 'ลำดับ',
    //   dataIndex: 'no',
    //   key: 'no',
    //   render: (value: any, record: any, index: number) => {
    //     return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
    //   },
    //   width: '60px',
    // },
    {
      title: 'เลขที่ใบกำกับภาษี',
      dataIndex: 'tax_invoice_no',
      key: 'tax_invoice_no',
      width: '160px',
      render: (val: string, record: TaxListData) => (
        <LinkNo onClick={() => onClickEdit(record)}>{val}</LinkNo>
      ),
    },
    {
      title: 'เลขที่คำสั่งซื้อ',
      dataIndex: 'order_no',
      key: 'order_no',
      width: '180px',
    },
    {
      title: 'ชื่อลูกค้า/บริษัท',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'เลขประจำตัวผู้เสียภาษี',
      dataIndex: 'taxpayer_no',
      key: 'taxpayer_no',
    },
    {
      title: <TextRight>จำนวน/รายการ</TextRight>,
      dataIndex: 'total_quantity',
      key: 'total_quantity',
      render: (val: number) => <TextRight>{numberWithComma(val)}</TextRight>,
    },
    {
      title: <TextRight>ยอดซื้อ</TextRight>,
      dataIndex: 'total_price',
      key: 'total_price',
      render: (val: number) => <TextRight>{numberWithComma(val, true)}</TextRight>,
    },
    {
      title: <TextRight>ยอดเงินคืน</TextRight>,
      dataIndex: 'refund_amount',
      key: 'refund_amount',
      render: (val: number) => <TextRight>{numberWithComma(val, true)}</TextRight>,
    },
    {
      title: '',
      width: '20px',
      dataIndex: '',
      key: 'space',
      render: () => '',
    },
    {
      title: 'ประเภท',
      key: 'invoice_type',
      dataIndex: 'invoice_type',
      render: renderTaxType,
    },
    {
      title: 'วันที่ออกใบกำกับภาษี',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (val: string) => formatDateTime(val),
      width: '100px',
    },
    {
      title: 'สถานะ',
      key: 'status',
      dataIndex: 'status',
      render: renderStatus,
    },
  ]

  const FilterContent = (
    <FilterWrapper>
      <Row gutter={[16, 16]}>
        <Col md={8} xs={24}>
          <SearchInput
            placeholder="ค้นหาเลขที่คำสั่งซื้อ เลขที่ใบกำกับภาษี ชื่อลูกค้า/บริษัท "
            prefix={<SearchOutlined />}
            allowClear
            value={filter.keyword}
            onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
          />
        </Col>
        <Col xs={24} md={4}>
          <SelectItem
            name={'invoice_type'}
            label={''}
            isRequired={true}
            value={filter.invoice_type}
            menu={menuTaxInvoiceType}
            placeHolder={'ประเภท'}
            onChange={(val: any): void => onFilter('invoice_type', val)}
          />
        </Col>
        <Col xs={24} md={4}>
          <SelectItem
            name={'status'}
            label={''}
            isRequired={true}
            value={filter.status}
            menu={menuTaxtatus}
            placeHolder={'สถานะ'}
            onChange={(val: any): void => onFilter('status', val)}
          />
        </Col>
        <Col xs={24} md={8}>
          <RangeDateItem
            placeHolder={['วันที่สร้างเริ่มต้น', 'สิ้นสุด']}
            onChange={handleChangeDate}
            startDate={filter.start_date}
            endDate={filter.end_date}
          />
        </Col>
        <Col>
          <Space>
            <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
            {/* <PrimaryButton icon={<DownloadOutlined />} text="Export" btnType="Primary" onClick={onExport} /> */}
            <PrimaryButton
              icon={<DownloadOutlined />}
              text="รายงานออกใบกำกับภาษี"
              btnType="Primary"
              onClick={onExport}
            />
          </Space>
        </Col>
      </Row>
      {selectedData?.invoice_type === TaxInvoiceType.SUPPLIER ? SupplierDetailDrawer : DetailDrawer}
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  return (
    <>
      {FilterContent}
      {ConfirmExportModal}
      <TableListPage
        columns={columns}
        datas={datas}
        isLoading={event.IsLoading}
        paginationContent={PaginationContent}
      />
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    dataList: selectTaxList(state),
    event: selectTaxListEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`
const TextRight = styled.div`
  text-align: right;
`

const LinkNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fontFamily.bold};
  color: ${theme.colors.primary};
`

export default connect(mapStateToProps)(TaxList)
